import useSWR from 'swr';
import { useMemo } from 'react';
// utils
import { fetcher, endpoints } from 'src/utils/axios';
// types
import { IProductItem, advtItem, dashboardcount } from 'src/types/product';


export function useGetDashboard() {

  const URL = endpoints.admin.totalcount;


  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher);
// console.log("data",data)
  const memoizedValue = useMemo(
    () => ({
      dashboarddata: (data?.results as dashboardcount[]) || [],
      productsLoading: isLoading,
      total: (data?.total as number || 0),
      productsError: error,
      productsValidating: isValidating,
    //   productsEmpty: !isLoading && !data?.data.length,
    }),
    [data?.results, data?.total, error, isLoading, isValidating]
  );

  return memoizedValue;
}